import { settingsActionTypes } from '@constants/actionTypes/ssapActionTypes';
import { ENABLED, DISABLED } from '@constants/ssap/miscellaneous/miscellaneous';

export const INITIAL_STATE = {
    alwaysDisplayMedicaidQuestions: false,
    autoReenrollSopaConsent: DISABLED,
    collectMemberRemovalReason: DISABLED,
    dacaEffective: null,
    displayItuQuestions: ENABLED,
    escUiUpdated: DISABLED,
    itfFeature: DISABLED,
    inlineCurrentIncomeEnabled: DISABLED,
    inlineEligibilityIgnoredForEscPage: DISABLED,
    collectLivingArrangement: DISABLED,
    medicaidEndDateOverride: 90,
    endDateOfPregnancyOverride: 60,
    medicaidTerminationFeature: DISABLED,
    realtimeCheck: DISABLED,
    sogiFeature: DISABLED,
    voterRegistrationFeature: DISABLED
};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case settingsActionTypes.SET_SSAP_SETTINGS:
            return {
                ...state,
                ...action.settings
            };
        case settingsActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

// Selectors

export const selectIfEscUIEnabled = state => state.escUiUpdated === ENABLED;
export const selectIfInlineEligibilityIgnoredForEscPage = state => state.inlineEligibilityIgnoredForEscPage === ENABLED;
export const selectIfLivingArrangement = state => state.collectLivingArrangement === ENABLED;
export const selectIsItfFeatureEnabled = state => state.itfFeature === ENABLED;
export const selectIsItuQuestionsDisabled = state => state.displayItuQuestions === DISABLED;
export const selectIsInlineCurrentIncomeEnabled = state => state.inlineCurrentIncomeEnabled === ENABLED;
export const selectIsMemberRemovalReasonEnabled = state => state.collectMemberRemovalReason === ENABLED;
export const selectDacaEffective = state => state.dacaEffective;
export const selectIfRealtimeCheckEnabled = state => state.realtimeCheck === ENABLED;
export const selectIfSogiFeatureEnabled = state => state.sogiFeature === ENABLED;
export const selectIfAutoReenrollSopaConsentEnabled = state => state.autoReenrollSopaConsent === ENABLED;
export const selectIfVoterRegistrationFeatureEnabled = state => state.voterRegistrationFeature === ENABLED;
export const selectIfAlwaysDisplayMedicaidQuestionsEnabled = state => state.alwaysDisplayMedicaidQuestions;
export const selectIfMedicaidTerminationFeatureEnabled = state => state.medicaidTerminationFeature === ENABLED;
export const selectMedicaidEndDateOverride = state => state.medicaidEndDateOverride;
export const selectEndDateOfPregnancyOverride = state => state.endDateOfPregnancyOverride;